/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Studio_SubInputs */

const en_mk_studio_sub = /** @type {(inputs: Mk_Studio_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your agent has already proven every task. Studio turns that evidence into what clients pay for: estimates, proposals, a progress page and a handover package.`)
};

const id_mk_studio_sub = /** @type {(inputs: Mk_Studio_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agent-mu sudah membuktikan tiap task. Studio mengubah bukti itu jadi hal yang dibayar klien: estimasi, proposal, halaman progres, dan paket serah terima.`)
};

/**
* | output |
* | --- |
* | "Your agent has already proven every task. Studio turns that evidence into what clients pay for: estimates, proposals, a progress page and a handover package." |
*
* @param {Mk_Studio_SubInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_studio_sub = /** @type {((inputs?: Mk_Studio_SubInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Studio_SubInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_studio_sub(inputs)
	return en_mk_studio_sub(inputs)
});